import React from 'react';
import { DatePicker } from 'smoothie';

import { datePlusOffset } from '../../../common/utils/billUtils';
import { getMidnightUTCDate } from '../../../common/utils/dateUtils';
import type { BillDetailsEditTypeProps } from '../edit/BillDetailsEditContainer';

const BillEditLastPaid = ({ bill, onChange }: BillDetailsEditTypeProps) => {
    return (
        <DatePicker
            maximumDate={new Date()}
            onChange={(date) => {
                const newBill = {
                    ...bill,
                    lastPaidAt: getMidnightUTCDate(date ?? new Date()),
                };
                onChange(newBill);
            }}
            value={datePlusOffset(bill.lastPaidAt ?? new Date())}
        />
    );
};

export default BillEditLastPaid;
